<script lang="ts">
    import { computed, onMounted, Ref, ref, toRaw } from 'vue';
    import { NodeType } from '@journeys/Enums';

    import vm, { JourneyNode } from '@journeys/Journeys.viewmodel';

    // components
    import FluidButton from '@cwd/shared/components/FluidButton.vue';
    import FluidInput from './FluidInput.vue';
    import { bitshift, deepClone, uid } from '@utils';
    // import { ENode } from '@cwd/Journeys/binaryWorker';

    // this is mostly for debugging, otherwise components are Anonymous
    const component = {
        name: 'ContextMenu',
    };
    export default {
        name: component.name,
    };
</script>

<script lang="ts" setup>
    const props = withDefaults(
        defineProps<{
            show: boolean;
            x: number;
            y: number;
            h: number;
            w: number;
            containerRect: DOMRect;
            nodeId: string;
            container: {
                h: number;
                w: number;
            };
            title?: string;
            margin?: number;
        }>(),
        {
            margin: 12,
        }
    );

    const { editor, viewport, settings, activeJourney } = vm;

    let menuRef = ref<HTMLElement>(),
        menuEl: HTMLElement | undefined;
    onMounted(() => {
        menuEl = menuRef.value;
    });

    const contained = computed(() => {
        let { x, y, h, w, container, margin } = props;
        return {
            x: x + w < container.w ? x : x - (x + w - container.w) - margin,
            y: y + h < container.h ? y : y - (y + h - container.h) - margin,
        };
    });

    const handleCopyToClipboard = () => {
        editor.tools.clipboard = editor.tools.sel_nodes;
        editor.tools.clipboard[props.nodeId] ||= activeJourney.nodes[props.nodeId];
        editor.events.emit('pasteselection');
        viewport.closeMenu('contextmenu');
    };

    const handleCutSelection = () => {
        handleCopyToClipboard();
        deleteNodes();
    };

    const deleteNodes = () => {
        editor.events.emit('deleteselection');
        editor.events.emit('deletenode', props.nodeId);
    };
</script>

<template>
    <transition name="quick-fade">
        <div
            class="context-menu"
            ref="menuRef"
            v-if="show"
            :style="{
                transform: `translate3d(${contained.x}px, ${contained.y}px, 0)`,
            }">
            <div class="context-item" v-if="activeJourney.nodes[nodeId].data.type !== NodeType.Text">
                <FluidInput
                    class="subheading minimal"
                    style="font-size: 85%"
                    placeholder="[Title]"
                    v-model:value="(activeJourney.nodes[nodeId] as JourneyNode).data.title" />
            </div>
            <!-- <FluidButton @click="handleCutSelection" text="Cut" class="context-button" /> -->
            <FluidButton
                @click="handleCopyToClipboard"
                :text="$Resources.GenericCloneLabel"
                class="btn btn-default btn-sm"
                :class="
                    (editor.tools.sel_count === 0 ||
                        (editor.tools.sel_count === 1 && Object.values(editor.tools.sel_nodes)[0].data.type === NodeType.Segment)) &&
                    'disabled'
                " />
            <!-- <FluidButton @click="editor.events.emit('addnodes')" text="Paste" :class="`context-button last-in-group ${ Object.keys(editor.tools.sel_nodes).length === 0 ? 'inactive' : '' }`"  /> -->
            <FluidButton @click="deleteNodes" :text="$Resources.DeleteBlockButton" class="btn btn-default btn-sm" />
        </div>
    </transition>
</template>

<style lang="less">
    .context-menu {
        display: flex;
        position: absolute;
        flex-direction: column;

        gap: 5px;
        padding: 5px;
        width: 8.1rem;
        top: 0;
        left: 0;

        background-color: white;
        overflow: hidden;
        z-index: 10;

        border-radius: var(--border-radius);
        box-shadow:
            0.1rem 0.5rem 0.7rem -0.2rem #00000015,
            -0.4rem -0.3rem 1rem -0.6rem #00000040;

        outline: var(--border-size) solid hsl(353deg 100% 98%);

        transform-origin: top;
        transition-property: transform, height;
        transition-duration: var(--td-four);
        transition-timing-function: var(--ttf-eager);
    }

    .context-menu .context-item {
        justify-content: center;
        align-items: flex-start;
        flex-direction: column;
    }
</style>
